// src/components/video/smoothClock.js
//
// A smooth "where is the song right now" for animation.
//
// <audio>.currentTime is the truth, but browsers only update it a few times a
// second (Safari especially, and anything playing from a blob or data URL).
// Reading it every frame makes animation step instead of glide. This keeps a
// clock that runs on performance.now() between updates and re-anchors to the
// audio whenever its time moves, so it can never drift away from the song.
//
//   const clock = makeSmoothClock(audioEl);
//   requestAnimationFrame(function frame() { draw(clock.now()); … });

export const makeSmoothClock = (audio) => {
  let anchorAudio = 0;
  let anchorPerf = 0;
  let last = -1;

  return {
    now() {
      const a = audio;
      if (!a) return 0;
      const at = a.currentTime || 0;
      const perf = performance.now() / 1000;
      if (a.paused || a.ended || a.seeking) {
        anchorAudio = at;
        anchorPerf = perf;
        last = at;
        return at;
      }
      // the audio's own clock moved: re-anchor to it
      if (at !== anchorAudio) {
        anchorAudio = at;
        anchorPerf = perf;
      }
      let t = anchorAudio + (perf - anchorPerf) * (a.playbackRate || 1);
      // never run more than a quarter second ahead of the audio
      if (t - at > 0.25) t = at;
      // never go backwards while playing (keeps hands and words from twitching)
      if (t < last && last - t < 0.3) t = last;
      last = t;
      return t;
    },
  };
};

export default makeSmoothClock;
